export default {
  CART: 'lettucegrow-cart-0115',
  OLD_CART: 'lettucegrow-cart-0330',
  USER: 'lettucegrow-user-0106',
  RESERVATION: 'lettucegrow-reservation-428',
};
